// excelReader.js
export const excelReader = {
	// 更新数据验证规则
	  validationRules: {
	    requiredFields: [
	      '商户订单号',
	      '轨迹开始时间',
	      '轨迹结束时间',
	      '收件人省份',
	      '收件人城市',
	      '收件人街道',
	      '收件人邮编',      // 邮编现在是必填
	      '发件人省份',
	      '发件人城市',
	      '发件人街道',
	      '发件人邮编'       // 邮编现在是必填
	    ],
	    
	    optionalFields: [
	      '电商平台',
	      '备注',
	      '收件人国家二字码',
	      '发件人国家二字码'
	    ],
	    
	    datePattern: /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/,
	    
	    // 新增：邮编验证规则
	    zipCodeRules: {
	      required: true,                    // 邮编必填
	      minLength: 5,                      // 最小长度5位
	      maxLength: 10,                     // 最大长度10位（考虑到扩展邮编）
	      pattern: /^\d{5}/,                 // 前5位必须是数字
	      description: '前5位必须是数字'
	    }
	  },
	// 验证单行数据
	validateRowData(row, rowIndex) {
		const errors = [];
		const warnings = [];

		// 1. 检查必填字段
		this.validationRules.requiredFields.forEach(field => {
			const value = row[field];
			if (value === undefined || value === null || String(value).trim() === '') {
				errors.push({
					row: rowIndex + 1,
					field,
					type: 'required',
					message: `第${rowIndex + 1}行: "${field}" 不能为空`
				});
			}
		});

		// 2. 检查日期格式
		const startTime = row['轨迹开始时间'];
		const endTime = row['轨迹结束时间'];

		if (startTime && String(startTime).trim() !== '') {
			const dateStr = String(startTime).trim();
			if (!this.validationRules.datePattern.test(dateStr)) {
				errors.push({
					row: rowIndex + 1,
					field: '轨迹开始时间',
					type: 'date_format',
					message: `第${rowIndex + 1}行: "轨迹开始时间" 格式必须为 yyyy/mm/dd hh:mm:ss`,
					value: dateStr
				});
			} else if (!this.isValidDate(dateStr)) {
				errors.push({
					row: rowIndex + 1,
					field: '轨迹开始时间',
					type: 'date_invalid',
					message: `第${rowIndex + 1}行: "轨迹开始时间" 不是有效的日期`,
					value: dateStr
				});
			}
		}

		if (endTime && String(endTime).trim() !== '') {
			const dateStr = String(endTime).trim();
			if (!this.validationRules.datePattern.test(dateStr)) {
				errors.push({
					row: rowIndex + 1,
					field: '轨迹结束时间',
					type: 'date_format',
					message: `第${rowIndex + 1}行: "轨迹结束时间" 格式必须为 yyyy/mm/dd hh:mm:ss`,
					value: dateStr
				});
			} else if (!this.isValidDate(dateStr)) {
				errors.push({
					row: rowIndex + 1,
					field: '轨迹结束时间',
					type: 'date_invalid',
					message: `第${rowIndex + 1}行: "轨迹结束时间" 不是有效的日期`,
					value: dateStr
				});
			}
		}

		// 3. 检查时间逻辑（结束时间不能早于开始时间）
		if (startTime && endTime &&
			this.isValidDate(String(startTime)) &&
			this.isValidDate(String(endTime))) {
			const startDate = this.parseDate(String(startTime));
			const endDate = this.parseDate(String(endTime));

			if (endDate < startDate) {
				errors.push({
					row: rowIndex + 1,
					field: '轨迹结束时间',
					type: 'date_logic',
					message: `第${rowIndex + 1}行: "轨迹结束时间" 不能早于 "轨迹开始时间"`
				});
			}
		}

		// 4. 检查邮编格式（美国邮编为5位数字）
		const receiverZip = row['收件人邮编'];
		const senderZip = row['发件人邮编'];

		if (receiverZip && String(receiverZip).trim() !== '') {
			const zipStr = String(receiverZip).trim();
			if (!/^\d{5}$/.test(zipStr)) {
				warnings.push({
					row: rowIndex + 1,
					field: '收件人邮编',
					type: 'zip_format',
					message: `第${rowIndex + 1}行: "收件人邮编" 格式可能不正确（应为5位数字）`,
					value: zipStr
				});
			}
		}

		if (senderZip && String(senderZip).trim() !== '') {
			const zipStr = String(senderZip).trim();
			if (!/^\d{5}$/.test(zipStr)) {
				warnings.push({
					row: rowIndex + 1,
					field: '发件人邮编',
					type: 'zip_format',
					message: `第${rowIndex + 1}行: "发件人邮编" 格式可能不正确（应为5位数字）`,
					value: zipStr
				});
			}
		}

		// 5. 检查订单号格式（不能包含特殊字符）
		const orderNo = row['商户订单号'];
		if (orderNo && String(orderNo).trim() !== '') {
			const orderStr = String(orderNo).trim();
			if (/[<>"']/.test(orderStr)) {
				errors.push({
					row: rowIndex + 1,
					field: '商户订单号',
					type: 'order_no_invalid',
					message: `第${rowIndex + 1}行: "商户订单号" 包含非法字符`,
					value: orderStr
				});
			}
		}

		return {
			errors,
			warnings,
			hasErrors: errors.length > 0,
			hasWarnings: warnings.length > 0
		};
	},
	// 格式化日期为标准格式
	formatDateToStandard(dateString) {
		if (!dateString) return '';

		try {
			// 尝试解析各种可能的日期格式
			const date = new Date(dateString);
			if (isNaN(date.getTime())) return dateString;

			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

			return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
		} catch (error) {
			return dateString;
		}
	},
	// 数据清理和标准化
	cleanAndStandardizeData(data) {
		return data.map((row, index) => {
			const cleanedRow = {
				...row
			};

			// 1. 电商平台为空时设为"未知平台"
			if (!cleanedRow['电商平台'] || String(cleanedRow['电商平台']).trim() === '') {
				cleanedRow['电商平台'] = '未知平台';
			}

			// 2. 标准化日期格式
			if (cleanedRow['轨迹开始时间']) {
				cleanedRow['轨迹开始时间'] = this.formatDateToStandard(String(cleanedRow['轨迹开始时间']));
			}

			if (cleanedRow['轨迹结束时间']) {
				cleanedRow['轨迹结束时间'] = this.formatDateToStandard(String(cleanedRow['轨迹结束时间']));
			}

			// 3. 去除字符串两端的空格
			Object.keys(cleanedRow).forEach(key => {
				if (typeof cleanedRow[key] === 'string') {
					cleanedRow[key] = cleanedRow[key].trim();
				}
			});

			// 4. 处理空字符串为null（可选）
			Object.keys(cleanedRow).forEach(key => {
				if (cleanedRow[key] === '') {
					cleanedRow[key] = null;
				}
			});

			return cleanedRow;
		});
	},
	// 增强的解析方法（包含验证和清理）
	parseAutoSignOrdersWithValidation(data) {
		try {

			if (!data || !Array.isArray(data)) {
				return {
					data: [],
					validation: {
						isValid: false,
						errors: [{
							message: '输入数据无效'
						}]
					},
					warnings: []
				};
			}

			// 1. 数据清理和标准化
			const cleanedData = this.cleanAndStandardizeData(data);

			// 2. 数据验证
			const validation = this.validateData(cleanedData);

			// 3. 只提取有效数据
			const validData = [];
			const validationResults = [];

			cleanedData.forEach((row, index) => {
				const rowValidation = this.validateRowData(row, index);
				validationResults.push(rowValidation);

				if (!rowValidation.hasErrors) {
					// 检查必要的字段是否存在
					const merchantOrderNo = row['商户订单号'] || row['订单号'] || '';
					const trackStartTime = row['轨迹开始时间'] || '';
					const trackEndTime = row['轨迹结束时间'] || '';

					if (merchantOrderNo) {
						const receiver = {
							province: row['收件人省份'] || row['收货人省份'] || '',
							city: row['收件人城市'] || row['收货人城市'] || '',
							street: row['收件人街道'] || row['收货人地址'] || '',
							countryCode: row['收件人国家二字码'] || 'US',
							zipcode: row['收件人邮编'] || ''
						};

						const sender = {
							province: row['发件人省份'] || row['发货人省份'] || '',
							city: row['发件人城市'] || row['发货人城市'] || '',
							street: row['发件人街道'] || row['发货人地址'] || '',
							countryCode: row['发件人国家二字码'] || 'US',
							zipcode: row['发件人邮编'] || ''
						};

						const order = {
							platform: row['电商平台'] || row['平台'] || '未知平台',
							merchantOrderNo,
							trackStartTime,
							trackEndTime,
							receiver,
							sender,
							remark: row['备注'] || '',
							_rowNumber: row._rowNumber || index + 1,
							_isValid: !rowValidation.hasErrors,
							_warnings: rowValidation.warnings
						};

						validData.push(order);
					}
				}
			});

			return {
				data: validData,
				validation,
				originalCount: data.length,
				validCount: validData.length,
				invalidCount: data.length - validData.length
			};

		} catch (error) {
			console.error('解析自动签收单失败:', error);
			return {
				data: [],
				validation: {
					isValid: false,
					errors: [{
						message: error.message
					}]
				},
				warnings: []
			};
		}
	},
	// 解析日期
	parseDate(dateString) {
		const normalized = dateString.replace(/\//g, '-');
		return new Date(normalized);
	},
	// 验证整个数据集
	validateData(data) {
		const allErrors = [];
		const allWarnings = [];
		let validRows = 0;
		let invalidRows = 0;

		data.forEach((row, index) => {
			const validation = this.validateRowData(row, index);

			if (validation.hasErrors) {
				invalidRows++;
				allErrors.push(...validation.errors);
			} else {
				validRows++;
			}

			if (validation.hasWarnings) {
				allWarnings.push(...validation.warnings);
			}
		});

		return {
			totalRows: data.length,
			validRows,
			invalidRows,
			errors: allErrors,
			warnings: allWarnings,
			isValid: invalidRows === 0
		};
	},
	// 日期有效性检查
	isValidDate(dateString) {
		try {
			// 将 yyyy/mm/dd 格式转换为 Date 可识别的格式
			const normalized = dateString.replace(/\//g, '-');
			const date = new Date(normalized);
			return date instanceof Date && !isNaN(date);
		} catch (error) {
			return false;
		}
	},
	// 读取Excel文件
	readExcelFile(file) {
		return new Promise((resolve, reject) => {
			try {
				// 检查文件是否存在
				if (!file) {
					reject(new Error('文件为空或未选择文件'));
					return;
				}

				// 检查文件类型
				const validTypes = [
					'application/vnd.ms-excel',
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					'.xls',
					'.xlsx'
				];

				const fileExt = '.' + file.name.split('.').pop().toLowerCase();

				if (!validTypes.includes(file.type) && !validTypes.includes(fileExt)) {
					reject(new Error('文件格式不支持，请上传Excel文件 (.xls, .xlsx)'));
					return;
				}

				const reader = new FileReader();

				reader.onload = (e) => {
					try {
						const data = e.target.result;

						// 这里的关键检查：确保data存在并且是ArrayBuffer类型
						if (!data) {
							reject(new Error('文件读取失败，数据为空'));
							return;
						}

						// 检查data类型，FileReader.readAsArrayBuffer返回的是ArrayBuffer
						if (!(data instanceof ArrayBuffer)) {
							reject(new Error('文件数据格式不正确'));
							return;
						}

						// 解析Excel
						this.parseExcelData(data, file.name)
							.then(resolve)
							.catch(reject);

					} catch (innerError) {
						console.error('处理文件数据时出错:', innerError);
						reject(new Error('处理文件数据失败: ' + innerError.message));
					}
				};

				reader.onerror = (error) => {
					console.error('FileReader错误:', error);
					reject(new Error('读取文件失败: ' + error));
				};

				reader.onabort = () => {
					reject(new Error('文件读取被中止'));
				};

				// 使用readAsArrayBuffer读取二进制数据
				reader.readAsArrayBuffer(file);

			} catch (outerError) {
				console.error('读取Excel文件时出错:', outerError);
				reject(new Error('读取Excel文件失败: ' + outerError.message));
			}
		});
	},

	// 解析Excel数据
	async parseExcelData(data, fileName) {
		try {

			if (!data || !(data instanceof ArrayBuffer)) {
				throw new Error('无效的Excel数据');
			}

			// 导入xlsx库
			let XLSX;
			try {
				XLSX = await import('xlsx');
			} catch (importError) {
				console.error('导入xlsx库失败:', importError);
				throw new Error('Excel处理库加载失败');
			}

			// 将ArrayBuffer转换为Workbook
			const workbook = XLSX.read(new Uint8Array(data), {
				type: 'array'
			});

			if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
				throw new Error('Excel文件中没有找到工作表');
			}

			const sheets = [];

			// 处理每个工作表
			for (let i = 0; i < workbook.SheetNames.length; i++) {
				const sheetName = workbook.SheetNames[i];
				const worksheet = workbook.Sheets[sheetName];


				// 提取表头和数据
				const sheetData = this.extractTableData(worksheet);

				// 计算行数和列数
				const range = worksheet['!ref'] ? XLSX.utils.decode_range(worksheet['!ref']) : null;

				sheets.push({
					sheetName,
					rowCount: sheetData.length,
					columnCount: sheetData.headers ? sheetData.headers.length : 0,
					totalRows: range ? range.e.r - range.s.r + 1 : 0,
					totalCols: range ? range.e.c - range.s.c + 1 : 0,
					isEmpty: sheetData.data.length === 0,
					headers: sheetData.headers,
					data: sheetData.data,
					rawData: sheetData.rawData // 保存原始数据，用于手动解析
				});
			}

			// 返回完整的Excel数据
			return {
				fileName,
				summary: {
					totalSheets: sheets.length,
					totalRows: sheets.reduce((sum, sheet) => sum + sheet.rowCount, 0),
					hasData: sheets.some(sheet => !sheet.isEmpty)
				},
				sheets
			};

		} catch (parseError) {
			console.error('解析Excel数据失败:', parseError);
			throw new Error('解析Excel文件失败: ' + parseError.message);
		}
	},

	// 提取表格数据
	extractTableData(worksheet) {
		try {
			let XLSX;
			try {
				// 动态导入xlsx库
				const xlsxModule = require('xlsx');
				XLSX = xlsxModule.default || xlsxModule;
			} catch (error) {
				console.warn('无法加载xlsx库，尝试使用其他方式');
			}

			if (!XLSX) {
				throw new Error('Excel处理库不可用');
			}

			// 将工作表转换为JSON数组
			const rawData = XLSX.utils.sheet_to_json(worksheet, {
				header: 1, // 以数组形式返回，第一行是表头
				defval: '', // 默认值为空字符串
				raw: false // 返回格式化后的值
			});

			if (!rawData || rawData.length === 0) {
				return {
					headers: [],
					data: [],
					rawData: []
				};
			}

			// 提取表头（第一行）
			const headers = rawData[0] || [];

			// 提取数据行（从第二行开始）
			const dataRows = rawData.slice(1);

			// 将数据行转换为对象数组
			const data = dataRows.map((row, rowIndex) => {
				const rowObj = {};

				// 处理每一列
				headers.forEach((header, colIndex) => {
					if (header && header.trim()) {
						const cellValue = row[colIndex] !== undefined ? String(row[colIndex]) : '';
						rowObj[header.trim()] = cellValue;
					}
				});

				// 添加行号（原始行号+1，因为表头占一行）
				rowObj._rowNumber = rowIndex + 2;

				return rowObj;
			}).filter(row => Object.keys(row).length > 1); // 过滤掉空行

			return {
				headers: headers.filter(h => h && h.trim()),
				data,
				rawData
			};

		} catch (error) {
			console.error('提取表格数据失败:', error);
			return {
				headers: [],
				data: [],
				rawData: []
			};
		}
	},

	// 解析自动签收单数据
	parseAutoSignOrders(data) {
		try {

			if (!data || !Array.isArray(data)) {
				console.warn('输入数据无效');
				return [];
			}

			const result = [];

			data.forEach((row, index) => {
				try {
					// 检查必要的字段是否存在
					const merchantOrderNo = row['商户订单号'] || row['订单号'] || '';
					const trackStartTime = row['轨迹开始时间'] || '';
					const trackEndTime = row['轨迹结束时间'] || '';

					// 如果缺少关键字段，跳过
					if (!merchantOrderNo) {
						console.warn(`第${index + 1}行缺少订单号，跳过`);
						return;
					}

					const receiver = {
						province: row['收件人省份'] || row['收货人省份'] || '',
						city: row['收件人城市'] || row['收货人城市'] || '',
						street: row['收件人街道'] || row['收货人地址'] || '',
						countryCode: row['收件人国家二字码'] || 'US',
						zipcode: row['收件人邮编'] || ''
					};

					const sender = {
						province: row['发件人省份'] || row['发货人省份'] || '',
						city: row['发件人城市'] || row['发货人城市'] || '',
						street: row['发件人街道'] || row['发货人地址'] || '',
						countryCode: row['发件人国家二字码'] || 'US',
						zipcode: row['发件人邮编'] || ''
					};

					const order = {
						platform: row['电商平台'] || row['平台'] || '未知平台',
						merchantOrderNo,
						trackStartTime,
						trackEndTime,
						receiver,
						sender,
						remark: row['备注'] || '',
						_rowNumber: row._rowNumber || index + 1
					};

					result.push(order);

				} catch (rowError) {
					console.error(`处理第${index + 1}行数据失败:`, rowError);
				}
			});
			return result;

		} catch (error) {
			console.error('解析自动签收单失败:', error);
			return [];
		}
	},

	// 获取统计信息
	getStatistics(data) {
		if (!data || !Array.isArray(data)) {
			return {
				total: 0,
				validDates: 0,
				byPlatform: {},
			};
		}

		const statistics = {
			total: data.length,
			validDates: 0,
			byPlatform: {},
		};

		// 统计各平台订单数
		data.forEach(item => {
			const platform = item.platform || '未知平台';
			const state = item.receiver.province || '未知州';

			// 统计平台
			if (!statistics.byPlatform[platform]) {
				statistics.byPlatform[platform] = 0;
			}
			statistics.byPlatform[platform]++;

			// 检查是否有有效日期
			if (item.trackStartTime && item.trackEndTime) {
				statistics.validDates++;
			}
		});

		return statistics;
	},

	// 导出为CSV
	exportToCsv(data) {
		if (!data || data.length === 0) {
			return '';
		}

		// 获取所有可能的列
		const allKeys = new Set();
		data.forEach(row => {
			// 包括顶层字段
			Object.keys(row).forEach(key => {
				if (!key.startsWith('_') && key !== 'receiver' && key !== 'sender') {
					allKeys.add(key);
				}
			});

			// 包括receiver和sender的子字段
			if (row.receiver) {
				Object.keys(row.receiver).forEach(key => {
					allKeys.add(`receiver_${key}`);
				});
			}

			if (row.sender) {
				Object.keys(row.sender).forEach(key => {
					allKeys.add(`sender_${key}`);
				});
			}
		});

		const headers = Array.from(allKeys);

		// 构建CSV行
		const rows = data.map(row => {
			return headers.map(header => {
				let value = '';

				// 处理receiver_和sender_前缀
				if (header.startsWith('receiver_')) {
					const field = header.substring(9); // 去掉'receiver_'
					value = row.receiver ? (row.receiver[field] || '') : '';
				} else if (header.startsWith('sender_')) {
					const field = header.substring(7); // 去掉'sender_'
					value = row.sender ? (row.sender[field] || '') : '';
				} else {
					value = row[header] || '';
				}

				// 处理特殊字符
				const strValue = String(value);
				if (strValue.includes(',') || strValue.includes('"') || strValue.includes('\n')) {
					return `"${strValue.replace(/"/g, '""')}"`;
				}
				return strValue;
			});
		});

		// 组合CSV内容
		return [
			headers.join(','),
			...rows.map(row => row.join(','))
		].join('\n');
	},
	// 新增：分块读取Excel
	async readExcelFileChunked(file, chunkSize = 1000) {
		return new Promise((resolve, reject) => {
			try {
				const reader = new FileReader();
				let chunks = [];
				let currentChunk = 1;
				let totalRows = 0;
				let headers = [];

				reader.onload = async (e) => {
					try {
						const data = e.target.result;

						if (!(data instanceof ArrayBuffer)) {
							reject(new Error('文件数据格式不正确'));
							return;
						}

						// 动态导入xlsx
						const XLSX = await import('xlsx');
						const workbook = XLSX.read(new Uint8Array(data), {
							type: 'array',
							cellFormula: false, // 不读取公式
							cellStyles: false, // 不读取样式
							cellDates: true // 优化日期处理
						});

						const firstSheetName = workbook.SheetNames[0];
						const worksheet = workbook.Sheets[firstSheetName];

						// 获取总行数
						const range = XLSX.utils.decode_range(worksheet['!ref']);
						totalRows = range.e.r - range.s.r;

						// 提取表头
						headers = [];
						for (let c = range.s.c; c <= range.e.c; c++) {
							const cell = worksheet[XLSX.utils.encode_cell({
								r: range.s.r,
								c
							})];
							headers.push(cell ? cell.v : `Column${c + 1}`);
						}

						// 分块处理数据
						const totalChunks = Math.ceil(totalRows / chunkSize);
						const result = {
							fileName: file.name,
							headers,
							totalRows,
							totalChunks,
							chunks: [],
							statistics: {
								total: 0,
								byPlatform: {},
							}
						};

						// 处理第一块用于预览
						const firstChunk = this.processChunk(worksheet, headers, 1, chunkSize,
							range);
						result.chunks.push(firstChunk);

						// 更新统计（只统计第一块）
						result.statistics.total = firstChunk.data.length;

						// 异步处理剩余块
						if (totalChunks > 1) {
							this.processRemainingChunksAsync(workbook, result, chunkSize)
								.then(() => resolve(result))
								.catch(reject);
						} else {
							resolve(result);
						}

					} catch (error) {
						reject(error);
					}
				};

				reader.onerror = reject;
				reader.readAsArrayBuffer(file);

			} catch (error) {
				reject(error);
			}
		});
	}, // 处理一个数据块
	processChunk(worksheet, headers, chunkIndex, chunkSize, range) {
		const XLSX = require('xlsx');
		const startRow = (chunkIndex - 1) * chunkSize + 1; // +1跳过表头
		const endRow = Math.min(startRow + chunkSize - 1, range.e.r);

		const chunkData = [];
		for (let r = startRow; r <= endRow; r++) {
			const rowObj = {};
			for (let c = 0; c < headers.length; c++) {
				const cell = worksheet[XLSX.utils.encode_cell({
					r,
					c
				})];
				rowObj[headers[c]] = cell ? cell.v : '';
			}
			if (Object.values(rowObj).some(val => val !== '')) {
				chunkData.push(rowObj);
			}
		}

		return {
			chunkIndex,
			startRow,
			endRow,
			data: chunkData,
			size: chunkData.length
		};
	}, // 异步处理剩余块
	async processRemainingChunksAsync(workbook, result, chunkSize) {
		return new Promise((resolve) => {
			// 使用setTimeout让出主线程
			setTimeout(async () => {
				const XLSX = await import('xlsx');
				const worksheet = workbook.Sheets[workbook.SheetNames[0]];
				const range = XLSX.utils.decode_range(worksheet['!ref']);

				for (let i = 2; i <= result.totalChunks; i++) {
					const chunk = this.processChunk(worksheet, result.headers, i, chunkSize,
						range);
					result.chunks.push(chunk);
					result.statistics.total += chunk.data.length;

					// 每处理一个块就让出主线程
					if (i % 3 === 0) {
						await new Promise(res => setTimeout(res, 0));
					}
				}

				resolve();
			}, 0);
		});
	}, // 优化版：读取Excel（带性能选项）
	async readExcelFileOptimized(file, options = {}) {
		const {
			maxRows = 5000, // 最大读取行数
				previewRows = 50, // 预览行数
				skipEmptyRows = true, // 跳过空行
				cellFormula = false, // 不读取公式
				cellStyles = false // 不读取样式
		} = options;

		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = async (e) => {
				try {
					console.time('Excel解析时间');

					const data = e.target.result;
					if (!(data instanceof ArrayBuffer)) {
						reject(new Error('文件数据格式不正确'));
						return;
					}

					const XLSX = await import('xlsx');
					const workbook = XLSX.read(new Uint8Array(data), {
						type: 'array',
						cellFormula,
						cellStyles,
						cellDates: true,
						dense: true // 使用密集模式，减少内存
					});

					const sheetName = workbook.SheetNames[0];
					const worksheet = workbook.Sheets[sheetName];

					// 获取数据范围
					const range = worksheet['!ref'] ?
						XLSX.utils.decode_range(worksheet['!ref']) : {
							s: {
								r: 0,
								c: 0
							},
							e: {
								r: 0,
								c: 0
							}
						};

					// 限制处理行数
					const actualRows = Math.min(range.e.r - range.s.r, maxRows);

					// 提取表头
					const headers = [];
					for (let c = range.s.c; c <= range.e.c; c++) {
						const cell = worksheet[XLSX.utils.encode_cell({
							r: range.s.r,
							c
						})];
						headers.push(cell ? String(cell.v).trim() : `Col${c + 1}`);
					}

					// 提取数据（限制行数）
					const dataArray = [];
					let processedRows = 0;

					for (let r = range.s.r + 1; r <= range.e.r && processedRows <
						actualRows; r++) {
						const rowObj = {};
						let isEmptyRow = true;

						for (let c = 0; c < headers.length; c++) {
							const cell = worksheet[XLSX.utils.encode_cell({
								r,
								c
							})];
							const value = cell ? cell.v : '';

							if (value !== '') isEmptyRow = false;
							rowObj[headers[c]] = value;
						}

						if (!skipEmptyRows || !isEmptyRow) {
							rowObj._rowNumber = r + 1;
							dataArray.push(rowObj);
							processedRows++;
						}

						// 每处理100行让出主线程一次
						if (processedRows % 100 === 0) {
							await new Promise(resolve => setTimeout(resolve, 0));
						}
					}

					console.timeEnd('Excel解析时间');
					console.log(`处理了 ${processedRows} 行数据，原始 ${actualRows} 行`);

					resolve({
						fileName: file.name,
						summary: {
							totalSheets: workbook.SheetNames.length,
							totalRows: processedRows,
							originalRows: range.e.r - range.s.r,
							limited: processedRows < (range.e.r - range.s.r),
							headersCount: headers.length
						},
						headers,
						data: dataArray,
						preview: dataArray.slice(0, previewRows),
						worksheet // 保留原始worksheet用于后续处理
					});

				} catch (error) {
					console.error('解析Excel失败:', error);
					reject(error);
				}
			};

			reader.onerror = reject;
			reader.readAsArrayBuffer(file);
		});
	}
	
};